package com.karawek.core.ui.designcatalog.sections

import androidx.compose.runtime.Composable
import androidx.compose.material3.Text
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun CatalogNavigation() {
    Text(
        text = "Navigation (Platform-specific)",
        style = CoreTypography.title,
    )

    Text(
        text = "This section demonstrates how bottom and top navigation differ between platforms.\n" +
                "Actual navigation behavior is implemented in MainShellUi.",
        style = CoreTypography.bodySecondary,
    )
}
